/* eslint-disable no-console */
/* eslint-disable max-len */
import React from 'react';
import { Box, Modal, Grid, Tooltip } from '@mui/material';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import SchematiDiagramSVG from './schematic-view-svg';

function EDISchematicView(props) {
  const { visibleEDISchematic, handleCloseEDISchematic, getEDIName, cocurrent, ediDetails } = props;
  let dilution_output = {
    'current_stack': 0,
    'voltage': '',
    'max_all_recovery': '',
    'energy_cons': '',
    'feed_flow': '',
    'feed_pressure': 0,
    'prod_flow': 0,
    'prod_pressure': '',
    'conc_bleed_flow': '',
    'electrode_bleed_flow': '',
    'max_conc_inlet_press': 0,
    'max_conc_outlet_press': 0,
    'max_electrode_bleed_press': 0,
    'Flow Configuration': 'Counter-Current'

  };
  if (localStorage.getItem('edi-output-dict')) {
    const outputdata = get(JSON.parse(localStorage.getItem('edi-output-dict')), `EDI.${ediDetails.id}`, {});
    // eslint-disable-next-line prefer-destructuring
    dilution_output = outputdata.output_user.dilution_output;
  }
  return (
    <Modal
      hideBackdrop
      open={visibleEDISchematic}
      onClose={handleCloseEDISchematic}
      className='splitter-modal'
    >
      <Box className=''>
        <Rnd
          default={{
            width: '70%',
            x: ((window.innerWidth / 2) - ((70 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((90 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          bounds='body'
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          onDragStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          minWidth='40%'
          cancel=".no_drag, .MuiOutlinedInput-root"
          className='edischematic-box'>
          <Grid container className='edischematic-grid-container'>
            <Grid item xs={12} className='edischematic-header-grid'>
              <div className='edischematic-grid-title rufusBld no_drag S_heading'>{`Schematic of EDI ${getEDIName()}`}</div>
              <div className='edischematic-grid-container'>
                <Tooltip title='Close'>
                  <img
                    src={closeIconBlack}
                    alt='close'
                    onClick={handleCloseEDISchematic}
                    style={{ width: '14px', padding: '11px' }}
                    className='pointer'
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid container style={{ 'margin': '16px' }}>
              <SchematiDiagramSVG
                cocurrent={cocurrent}
                ediDetails={ediDetails}
              />
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
}

export default EDISchematicView;